import { AddressZero, AlternativeAddressZero } from '../constants.js';
export const isZeroAddress = (address) => {
    if (address === AddressZero || address === AlternativeAddressZero) {
        return true;
    }
    return false;
};
//# sourceMappingURL=isZeroAddress.js.map